import { isInIframe } from '../lib/utils';
const config = {
    default: {
        API_URL: 'http://localhost:4000',
        PROJECT: 'theStocks',
        REPORT_URL: 'http://localhost:3000',
        CDN_URL: 'https://cdn.designerdailyreport.com',
        PANDA_API: 'http://api.pndlocal.gs:2830',
        PANDALYTICS_API: 'http://localhost:1000',
        WEB_REQUEST_CONFIG: {
            extension: {
                self: true,
                name: 'The Stocks',
            },
            web: {
                helperExtension: false,
                enabled: !isInIframe(),
            },
        },
    },
    production: {
        API_URL: 'https://api.designerdailyreport.com',
        REPORT_URL: 'https://app.designerdailyreport.com',
        PANDA_API: 'https://api-panda.com',
        PANDALYTICS_API: 'https://al.designerdailyreport.com',
    },
};
const getConfig = (configKey) => {
    const allConfig = Object.assign(Object.assign({}, config.default), (process.env.NODE_ENV === 'production' ? config.production : {}));
    return allConfig[configKey];
};
export default getConfig;
